export const RESELL_DEVICE_TITLE =
  'Are you sure you want to resell this device?';

export const RESELL_DEVICE_SUBTITLE =
  'A team member will reach out with a quote for your approval before reselling the device.';

export const SAVE_BUTTON_COPY = 'Yes, resell';
